$(document).on("turbolinks:load", function() {

    $("table[role='datatable']").each(function (e) {
        var oTable = $(this).DataTable({
            dom: 'Bfrtip',
            "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],

            bProcessing: true,
            bServerSide: true,
            bLengthChange: true,
            bInfo: true,
            language: {search: "Search : ", searchPlaceholder: "search"},
            "ordering": true,
            "order": [],
            "aoColumnDefs": [
                {'bSortable': false, 'aTargets': [-1, "no-sort"]}
            ],
            sAjaxSource: $(this).data('source')
        });
    });
});

export function init_filepond_image() {
    $(".filepond-single").each(function () {
        if ($(this).data("name")) {
            createimagePoster(
                this,
                $(this).data("name"),
                $(this).data("size"),
                $(this).data("type"),
                $(this).data("url"),
                $(this).data("remove-url"),
                $(this).data("id"),
            );
        } else {
            FilePond.create(this, {
            name: "filepond",
        });
        }
    });
}
function createimagePoster(input, name, size, type, url, delete_url, item_id) {
    FilePond.create(input, {
        name: "filepond",
        instantUpload: true,
        imagePreviewHeight: 100,
        filePosterHeight: 200,
        filePosterMaxHeight: 200,
        files: [{
            options: {
                file: {
                    name: name,
                    size: size,
                    type: type
                },
                metadata: {
                    poster: url
                }
            }
        }]
    });
    $(".filepond-single").on("FilePond:removefile", function (e) {
        var id = item_id;
        if (id) {
            $.ajax({
                url: delete_url,
                type: "POST",
                datatype: "Script",
                data: {id: id},
                success: function (result) {
                }
            });
        }
    });
}

$( document ).on('turbolinks:load', function() {
    init_filepond_image();
})
